import { jsx as _jsx } from "react/jsx-runtime";
import ConfigProvider, { useTrackConfig } from './ConfigProvider';
import TrackProvider, { useTrackEvent, useTrackPageView } from './TrackProvider';
const Tracker = ({ collect, provider, children, ...props }) => (_jsx(ConfigProvider, Object.assign({}, props, { children: _jsx(TrackProvider, Object.assign({ collect: collect, provider: provider }, { children: children }), void 0) }), void 0));
export default Tracker;
export { useTrackConfig, useTrackEvent, useTrackPageView, };
